import { render } from "./RankQuery.vue?vue&type=template&id=4d0c530b&scoped=true"
import script from "./RankQuery.vue?vue&type=script&lang=js"
export * from "./RankQuery.vue?vue&type=script&lang=js"

import "./RankQuery.vue?vue&type=style&index=0&id=4d0c530b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0c530b"]])

export default __exports__